import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { io } from "socket.io-client";

import { ChatbotAction } from "../../store/actions";

import ChatbotPopupStudent from "./chatbot-popup-students";
import ChatbotPopupSupport from "./chatbot-popup-support";

import Spacer from "../spacer";
import tabs from "../tabs";

import { Images } from "../../config";

const socket = io(process.env.REACT_APP_BACKEND_URL, {
  transports: ["websocket"],
  withCredentials: true,
});

const ChatbotPopupContent = () => {
  const dispatch = useDispatch();

  const profileData = useSelector((state) => state.profile?.user);
  const schoolId =
    profileData?.role === "school"
      ? profileData?.schoolId
      : profileData?.staff?.schoolId;

  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    setActiveTab("student");
  }, [profileData]);

  useEffect(() => {
    const handleUser = () => {
      const payload = { schoolId };
      dispatch(
        ChatbotAction.getUsers(payload, () => {
          dispatch(
            ChatbotAction.getUnreadMessages({
              from: profileData?.id,
            })
          );
        })
      );
    };

    socket.on("message-sent", handleUser);
    socket.on("message-received", handleUser);

    return () => {
      socket.off("message-sent", handleUser);
      socket.off("message-received", handleUser);
    };
  }, [profileData]);

  const tabItems = [
    {
      title: "Student",
      value: "student",
    },
    { title: "Support", value: "support" },
  ];

  return (
    <div className="flex flex-col justify-center items-center w-[21.875em]">
      <div className="flex justify-between items-center w-full px-5">
        <tabs.ChatbotPopupTab
          tabs={tabItems}
          activeTab={activeTab}
          onTabClick={setActiveTab}
        />
        <img src={Images.ChatbotPopupIcon} className="h-[2.25em] w-[2.25em]" />
      </div>
      <Spacer height={10} />
      {activeTab === "student" ? (
        <ChatbotPopupStudent />
      ) : (
        <ChatbotPopupSupport />
      )}
    </div>
  );
};

export default ChatbotPopupContent;
